import { Grid2 } from "@mui/material";
import React from "react";
import FormDateField from "../../../../component/form/FormDateField";
import FormFileInputField from "../../../../component/form/FormFileInputField";
import FormTextField from "../../../../component/form/FormTextField";

export default function RecieptDetails({ control }) {
  return (
    <>
      <Grid2 size={{ xs: 12, lg: 4 }}>
        <FormTextField
          placeholder="Receipt No"
          label="Receipt No"
          fieldname="receiptNo"
          control={control}
          required={true}
        />
      </Grid2>
      <Grid2 size={{ xs: 12, lg: 4 }}>
        <FormTextField
          label="Amount paid for device"
          placeholder="Amount in PKR"
          fieldname="amountPaid"
          control={control}
          required={true}
          type="number"
          rules={{
            min: { value: 0, message: "Select non-negative value." },
          }}
        />
      </Grid2>
      <Grid2 size={{ xs: 12, lg: 4 }}>
        <FormDateField
          label="Date of purchase"
          fieldname="dateOfPurchase"
          control={control}
          required={true}
        />
      </Grid2>
      <Grid2 size={12}>
        <FormFileInputField
          label="Please upload prescription provided by the doctor"
          control={control}
          fieldname="prescription"
          acceptedExtensions={["png", "jpg", "jpeg", "pdf"]} // Include all common image extensions and PDFs
          required={true}
          maxFileSize={32 * 1024 * 1024} // Max file size of 32 MB
        />
      </Grid2>
      <Grid2 size={12}>
        <FormFileInputField
          label="Please upload a clear image or scan of your purchase receipt"
          control={control}
          acceptedExtensions={["png", "jpg", "jpeg", "pdf"]} // Include all common image extensions and PDFs
          fieldname="receipt"
          required={true}
          maxFileSize={32 * 1024 * 1024} // Max file size of 32 MB
        />
      </Grid2>
    </>
  );
}
